import { Injectable } from '@angular/core';
import { IplpRecipeDetailObject, IplpRecipeObject } from '@libs/types/src/list/object-type/iplp-recipe.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class IplpRecipeGqlService extends GqlServiceV2 {
    public getIplpRecipes(fragment: string): Promise<IplpRecipeObject[]> {
        return this.query<IplpRecipeObject[]>(`
            query IplpRecipes {
                iplpRecipe {
                    list {
                        ${fragment}
                    }
                }
            }
        `, {}, {
            errorPolicy: 'none',
            context: { suppressGlobalErrors: true },
        });
    }

    public getIplpRecipeDetail(slug: string, fragment: string): Promise<IplpRecipeDetailObject> {
        return this.query<IplpRecipeDetailObject>(`
            query IplpRecipeDetail($slug: String!) {
                iplpRecipe {
                    detail(slug: $slug) {
                        ${fragment}
                    }
                }
            }
        `, { slug }, {
            errorPolicy: 'none',
            context: { suppressGlobalErrors: true },
        });
    }
}
